'use client';

import {
  NavigationDrawerBar,
  NavigationDrawerBarLabel,
  NavigationDrawerBarLead,
  NavigationDrawerBarTitle,
} from '@vs-shop/commerce-ui/navigationDrawer';
import { DialogClose } from '@vs-shop/ui/dialog';
import { IconTouchable } from '@vs-shop/ui/iconTouchable';
import { ChevronLeft, X } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  title: string | null;
  canGoBack: boolean;
  onGoBackAction: () => void;
};

export default function MobileNavigationHeader({ title, canGoBack, onGoBackAction }: Props) {
  const intl = useIntl();

  return (
    <NavigationDrawerBar>
      {/* BACK BUTTON */}
      <NavigationDrawerBarLead>
        {canGoBack && (
          <IconTouchable
            onClick={onGoBackAction}
            aria-label={intl.formatMessage({
              id: 'component.client.navigation.mobile.mobileNavigationHeader.back',
              defaultMessage: 'Zpět',
            })}
          >
            <ChevronLeft className="size-7 shrink-0" />
          </IconTouchable>
        )}
      </NavigationDrawerBarLead>

      {/* TITLE */}
      <NavigationDrawerBarTitle>
        {title !== null ? <NavigationDrawerBarLabel>{title}</NavigationDrawerBarLabel> : null}
      </NavigationDrawerBarTitle>

      {/* CLOSE BUTTON */}
      <DialogClose
        data-slot="mobile-navigation-close"
        render={
          <IconTouchable
            aria-label={intl.formatMessage({
              id: 'component.client.navigation.mobile.mobileNavigationHeader.closeMenu',
              defaultMessage: 'Zavřít menu',
            })}
          >
            <X className="size-7 shrink-0" />
          </IconTouchable>
        }
      />
    </NavigationDrawerBar>
  );
}
